import { render } from "./PaymentFailure.vue?vue&type=template&id=6a746dec"
const script = {}

import exportComponent from "/Users/computerscience/Desktop/connect-dashboard/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__